/**
 * Sickboy Market — Personalizzazioni runtime del cart drawer OCU
 * 1) Inietta il totale dentro il bottone "Checkout"
 * 2) Inietta l'etichetta dello sconto applicato dopo il valore "Sconto"
 *
 * OCU/Zipify e una single-page-app Vue: il drawer viene rirenderizzato
 * a ogni update (qty, add, remove). Ricolleghiamo ad ogni evento.
 */
(function () {
  'use strict';

  /* =========================================================
     1) TOTALE NEL BOTTONE CHECKOUT
     =========================================================
     La struttura DOM di OCU e:
       <button class="ocu-checkout-button">
         <div class="ocu-checkout-button-text">   <- TextEditor wrapper
           <p>Checkout</p>                        <- "Checkout" styled
         </div>
       </button>
     Append nel button-text finiva FUORI dalla pillola styled di TextEditor
     (era il bug del totale nero sotto il bottone). Quindi appendiamo
     come figlio diretto del <button>, e via CSS forziamo button = flex
     con il totale inline accanto al testo. */
  function syncTotalToCheckoutBtn() {
    var btn = document.querySelector('.ocu-checkout-button');
    var estimatedInfo = document.querySelector('.ocu-estimated-info');
    if (!btn || !estimatedInfo) return;

    var valueEl = estimatedInfo.lastElementChild;
    if (!valueEl) return;

    var total = (valueEl.textContent || '').trim();
    if (!total) return;

    // Rimuovi il codice valuta "EUR" finale: vogliamo solo il simbolo €
    // (es. "€60,88 EUR" -> "€60,88"). Tollerante a maiuscole/minuscole/spazi.
    total = total.replace(/\s*EUR\s*$/i, '');

    var existing = btn.querySelector('.sbm-checkout-total');
    if (existing) {
      existing.textContent = total;
    } else {
      var span = document.createElement('span');
      span.className = 'sbm-checkout-total';
      span.textContent = total;
      btn.appendChild(span);
    }
  }

  /* =========================================================
     2) ETICHETTA SCONTO APPLICATO
     =========================================================
     Shopify espone gli sconti in 2 posti dentro /cart.js:
       - cart.cart_level_discount_applications (sconti ordine)
       - item.line_level_discount_allocations[].discount_application
         (sconti su singola riga — qui finiscono gli automatici a volume)
     Leggiamo entrambi, deduplichiamo, e iniettiamo l'etichetta dentro
     .ocu-discount-info come pillola dopo il valore "-€10,72". */
  function syncDiscountLabel() {
    var discountInfo = document.querySelector('.ocu-discount-info');
    if (!discountInfo) return;

    // /cart.js e cached da Shopify, e velocissimo
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var titles = [];

        // Sconti a livello ordine
        (cart.cart_level_discount_applications || []).forEach(function (d) {
          if (d.title && titles.indexOf(d.title) === -1) titles.push(d.title);
        });

        // Sconti a livello item (sconti automatici Shopify a volume di solito stanno qui)
        (cart.items || []).forEach(function (item) {
          (item.line_level_discount_allocations || []).forEach(function (a) {
            var t = a && a.discount_application && a.discount_application.title;
            if (t && titles.indexOf(t) === -1) titles.push(t);
          });
        });

        // Nessuno sconto attivo: rimuovi badge se esisteva
        var existing = discountInfo.querySelector('.sbm-discount-label');
        if (titles.length === 0) {
          if (existing) existing.remove();
          return;
        }

        // Inietta o aggiorna
        if (existing) {
          existing.textContent = titles.join(' + ');
        } else {
          var span = document.createElement('span');
          span.className = 'sbm-discount-label';
          span.textContent = titles.join(' + ');
          discountInfo.appendChild(span);
        }
      })
      .catch(function (err) {
        console.warn('[SBM cart] discount label sync failed', err);
      });
  }

  /* =========================================================
     BOOTSTRAP — esegui dopo render Vue
     ========================================================= */
  function syncAll() {
    // setTimeout 0 -> aspetta che Vue finisca di renderizzare il drawer
    setTimeout(function () {
      syncTotalToCheckoutBtn();
      syncDiscountLabel();
    }, 0);
  }

  ['ocu:cart:loaded', 'ocu:cart:opened', 'ocu:cart:updated'].forEach(function (evt) {
    window.addEventListener(evt, syncAll);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(syncAll, 100);
    });
  } else {
    setTimeout(syncAll, 100);
  }
})();